import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { host } from "../../api/ApiCalls";
import { Calendar, User, Mail } from "lucide-react";
import Lottie from "lottie-react";
import Loading from "../../assets/Loading.json";

const StudentProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStudent = async () => {
      try {
        const res = await axios.get(`${host}/api/student/${id}`);
        console.log("Student Data:", res.data);
        setStudent(res.data);
      } catch (err) {
        console.error("Error fetching student:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchStudent();
  }, [id]);

if (loading) {
    return (
      <div className="flex items-center justify-center text-gray-800 m-8">
        <div className="w-80">
          <Lottie animationData={Loading} loop={true} />
        </div>
      </div>
    );
  }  if (!student) return <div className="text-center py-20">Student not found</div>;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 🔹 Hero */}
      <div className="bg-gradient-to-r from-indigo-500 to-indigo-700 shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 flex flex-col md:flex-row items-center gap-10">
          <img
            src={student._doc.avatar}
            alt={student._doc.name}
            className="w-40 h-40 rounded-full object-cover border-4 border-white shadow-xl"
          />
          <div className="text-white text-center md:text-left">
            <h1 className="text-4xl font-bold">{student._doc.name}</h1>
            <p className="text-lg text-teal-200 mt-1 flex items-center justify-center md:justify-start">
              <Mail className="w-5 h-5 mr-2" /> {student._doc.email}
            </p>
          </div>
        </div>
      </div>

      {/* 🔹 Enrolled Courses */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="text-3xl font-bold text-gray-800 mb-6">Enrolled Courses</h2>

        {student.enrolledCourses?.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {student._doc.enrolledCourses.map((course) => (
              <div
                key={course._id}
                className="bg-white shadow-md rounded-lg overflow-hidden transform transition duration-300 hover:scale-105 cursor-pointer"
                onClick={() => navigate(`/courses/${course._id}`)}
              >
                <img
                  src={course.image || "https://via.placeholder.com/300"}
                  alt={course.title}
                  className="w-full h-40 object-cover"
                />
                <div className="p-4">
                  <h3 className="text-xl font-semibold text-gray-900">
                    {course.title}
                  </h3>
                  <p className="text-gray-600 mt-1">{course.description}</p>
                  <p className="text-sm mt-2 text-gray-500">
                    Teacher: {course.teacher?.name || "N/A"}
                  </p>
                  {course.nextSession && (
                    <div className="flex items-center text-sm text-green-700 mt-2">
                      <Calendar className="h-4 w-4 mr-1" />
                      Next Session:{" "}
                      {new Date(course.nextSession).toLocaleString()}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-600">No enrolled courses found.</p>
        )}
      </div>
    </div>
  );
};

export default StudentProfile;
